import React from 'react';
import styleService from '@nykaa/deals-utils/styles';
import styled from '../../../theme';
const { getMarginStyles, setVisibility, } = styleService.utils;
export const StickersStyled = styled.div `
  width: 33px;
  height: 33px;
  background-size: contain;
  background-image: url(${({ url }) => url});
  background-repeat: no-repeat;
  background-position: center;
  ${({ margin }) => getMarginStyles(margin)};
  ${({ visible, visibility }) => visibility && setVisibility(visible)};
`;
const Stickers = ({ style, url, visibility }) => React.createElement(StickersStyled, Object.assign({}, style, { url: url, visibility: visibility }));
export default Stickers;
